<template>
  <!-- İçerik henüz gelmeden, gelecek düzenin taslağını gösterir (Linear/Notion/GitHub/Stripe
       deseni) — spinner + "Yükleniyor..." yerine, sayfa tipine göre şekillenen gri bloklar.
       `tur` verilmezse "sayfa" varsayılanı kullanılır; mevcut çağrıların tamamı prop geçmiyor. -->
  <div class="w-full" aria-busy="true" aria-live="polite">
    <!-- sayfa (varsayılan): başlık + istatistik kartları + tablo benzeri liste -->
    <template v-if="tur === 'sayfa'">
      <div class="flex items-center justify-between gap-3 mb-5">
        <Skeleton width="12rem" height="1.75rem" :animation="animasyon" />
        <Skeleton width="8rem" height="2.5rem" borderRadius="0.5rem" :animation="animasyon" />
      </div>

      <div class="grid grid-cols-2 sm:grid-cols-4 gap-3 mb-5">
        <Skeleton v-for="n in 4" :key="'kpi-' + n" height="5.5rem" borderRadius="0.75rem" :animation="animasyon" />
      </div>

      <div class="flex flex-col gap-3">
        <div v-for="n in 5" :key="'satir-' + n" class="flex items-center gap-3">
          <Skeleton shape="circle" size="2.25rem" :animation="animasyon" />
          <Skeleton height="1rem" width="30%" :animation="animasyon" />
          <Skeleton height="1rem" width="20%" :animation="animasyon" />
          <Skeleton height="1rem" width="15%" class="ml-auto" :animation="animasyon" />
        </div>
      </div>
    </template>

    <!-- liste: arama/filtre çubuğu + tekrar eden satırlar -->
    <template v-else-if="tur === 'liste'">
      <div class="flex flex-col sm:flex-row gap-2 mb-5">
        <Skeleton height="2.5rem" borderRadius="0.5rem" class="flex-1" :animation="animasyon" />
        <Skeleton width="8rem" height="2.5rem" borderRadius="0.5rem" :animation="animasyon" />
      </div>

      <div class="flex flex-col gap-4">
        <div v-for="n in 6" :key="'liste-' + n" class="flex items-center gap-3">
          <Skeleton shape="circle" size="2.5rem" :animation="animasyon" />
          <div class="flex-1 flex flex-col gap-2">
            <Skeleton height="0.9rem" width="40%" :animation="animasyon" />
            <Skeleton height="0.75rem" width="25%" :animation="animasyon" />
          </div>
          <Skeleton width="5rem" height="1.75rem" borderRadius="9999px" :animation="animasyon" />
        </div>
      </div>
    </template>

    <!-- form: etiket + alan çiftleri, altta aksiyon butonları -->
    <template v-else-if="tur === 'form'">
      <Skeleton width="10rem" height="1.5rem" class="mb-5" :animation="animasyon" />

      <div class="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-5">
        <div v-for="n in 6" :key="'alan-' + n" class="flex flex-col gap-2">
          <Skeleton height="0.85rem" width="35%" :animation="animasyon" />
          <Skeleton height="2.5rem" borderRadius="0.5rem" :animation="animasyon" />
        </div>
      </div>

      <div class="flex justify-end gap-2">
        <Skeleton width="6rem" height="2.5rem" borderRadius="0.5rem" :animation="animasyon" />
        <Skeleton width="6rem" height="2.5rem" borderRadius="0.5rem" :animation="animasyon" />
      </div>
    </template>

    <!-- kart: kart ızgarası -->
    <template v-else-if="tur === 'kart'">
      <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
        <div v-for="n in 6" :key="'kart-' + n" class="flex flex-col gap-3 p-4 border border-gray-200 dark:border-gray-700 rounded-lg">
          <Skeleton shape="circle" size="2.5rem" :animation="animasyon" />
          <Skeleton height="1rem" width="60%" :animation="animasyon" />
          <Skeleton height="0.8rem" width="100%" :animation="animasyon" />
          <Skeleton height="0.8rem" width="80%" :animation="animasyon" />
        </div>
      </div>
    </template>
  </div>
</template>

<script>
export default {
  name: "WaitSkeleton",
  props: {
    tur: {
      type: String,
      default: "sayfa",
      validator: (deger) => ["sayfa", "liste", "form", "kart"].includes(deger),
    },
  },
  data() {
    return {
      // prefers-reduced-motion altında PrimeVue Skeleton'ın kayan shimmer'ı kapatılır.
      animasyon: window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches ? "none" : "wave",
    };
  },
};
</script>
